<div class="row d-md-none">
  <div class="col-md-12 col-sm-12" *ngIf="showChannelDropdown">
    <platform-select (changePlatformEvent)="onChangePlatform($event)"></platform-select>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="influencer-section global-kpi no-bg">
      <kpi-report [kpi]="channelKpi"
                  [showKpiStatus]="true">
      </kpi-report>
    </div>
  </div>
  <div class="post-collection influencer-post-section" >
    <div class="col-md-12 col-sm-12 order-bar-container influencer-order-bar-container">
      <order-bar [discoverFilter]="currentFilterSearch" (eventOrderDiscoverList)="orderPostList($event)"></order-bar>
    </div>
    <achoo-infinite-scroll [scrollDistance]="scrollDistance"
                           [infiniteScrollThrottle]="throttle"
                           (scrollDownEvent)="onScrollDown()">
      <div class="post-content post-contents" *ngIf="isAuthorized">
        <post-list-mansonry #DiscoverPostList *ngIf="posts"
                       [postList]="posts"
                       [previewMode]="true"
                       [influencerGroupId]="influencerGroupId"
                       [gutter]="0"
                       [target]="target"
                       [displayMode]="'mobile'">
        </post-list-mansonry>
      </div>
    </achoo-infinite-scroll>
    <div class="d-block d-sn-none post-list-loading">
      <div *ngIf="isLoading" class="loader-circle center"><span></span></div>
    </div>
  </div>

  <div class="col-md-12 col-sm-12" *ngIf="!isAuthorized">
    <div class="note">
      <div class="title">{{'profile.title' | translate}}</div>
      {{'profile.content' | translate}}
    </div>
  </div>
</div>

<influencer-overview-detail-popup
  class="d-md-none"
  [isShow]="isShowPopUp"
  [post]="currentPost"
  (closePopupCardHover)="hidePopup()"
>
</influencer-overview-detail-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-tab.component.html